export default "__VITE_ASSET__BFHuV0Vg__"